module.exports = __webpack_public_path__ + "static/media/ukonsentrert.d7457850.m4a";